import IdDefinition from "./IdDefinition";
export default IdDefinition;
